export default {
    data: function () {
        return {
            scripts_loaded: false
        }
    },
    methods: {
        initMap(provider, fixSize) {

            if (provider === 'google') {

                setTimeout(() => {
                    let mapContainer = document.getElementById('mapdiv');
                    let mapContainerWidth = mapContainer.offsetWidth - fixSize;
                    let mapContainerHeight = mapContainer.offsetHeight - fixSize;

                    let map = document.querySelector('#mapdiv iframe');

                    map.style.width = mapContainerWidth + 'px';
                    map.style.height = mapContainerHeight + 'px';

                }, 300);

                return;
            }

            if (!this.scripts_loaded) {
                this.loadMapScripts();
                this.scripts_loaded = true;
            }

            setTimeout(() => {

                let platform = new H.service.Platform({
                    apikey: this.apikey
                });
                let defaultLayers = platform.createDefaultLayers();

                let map = new H.Map(document.getElementById('mapdiv'),
                    defaultLayers.raster.normal.map, {
                        center: {lat: this.details.lat, lng: this.details.lng},
                        zoom: 13,
                        pixelRatio: window.devicePixelRatio || 1
                    });
                window.addEventListener('resize', () => map.getViewPort().resize());

                map.addEventListener('pointermove', function (event) {
                    if (event.target instanceof H.map.Marker) {
                        map.getViewPort().element.style.cursor = 'pointer';
                    } else {
                        map.getViewPort().element.style.cursor = 'auto';
                    }
                }, false);

                let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));

                let ui = H.ui.UI.createDefault(map, defaultLayers);

                let parisPngIcon = new H.map.Icon("https://i.ibb.co/549yxc9/theme-pin.png", {size: {w: 56, h: 56}});

                let group = new H.map.Group();

                map.addObject(group);

                map.addEventListener('tap', function (evt) {
                    $('.H_el').remove();
                    if (typeof evt.target.data == "string") {
                        let bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
                            content: evt.target.getData()
                        });
                        ui.addBubble(bubble);
                    }
                });

                let details = '<b>' + this.details.name + '</b> <br>' +
                    this.details.address + ' <br>' +
                    '<a target="_blank" class="btn btn-primary sm:flex-no-grow flex-grow px-5 py-1" href="http://maps.google.com/maps?q=loc:' + this.details.lat + ',' + this.details.lng + '">' + this.get_route + '</a>';

                this.addMarkerToGroup(group, {lat: this.details.lat, lng: this.details.lng}, details, parisPngIcon);

            }, 1500);
        },
        addMarkerToGroup: function (group, coordinate, html, image) {
            let marker = new H.map.Marker(coordinate, {icon: image});
            marker.setData(html);
            group.addObject(marker);
        },
        loadMapScripts() {
            let _this = this;

            const {['main']: main, ...rest} = this.heremaps_scripts;

            this.loadScript(this.heremaps_css, 'css');

            this.loadScript(main, 'js', function () {
                Object.keys(rest).forEach(key => {
                    if (key !== 'clustering') {
                        _this.loadScript(rest[key]);
                    }
                });
            });
        },
        loadScript(url, type = 'js', callback) {
            let head = document.head, element;

            if (type === 'css') {
                element = document.createElement("link");
                element.rel = "stylesheet";
                element.type = "text/css";
                element.href = url;
            } else {
                element = document.createElement('script');
                element.type = 'text/javascript';
                element.src = url;
            }

            if (callback) {
                element.onreadystatechange = callback;
                element.onload = callback;
            }

            head.appendChild(element);
        },
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins.js